import { Injectable } from '@angular/core';
import { Vistoria } from '@tivic-team/manager-ts/dist/mob/entities/vistoria/vistoria.entity';
import { HttpDelete, HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';
import { VistoriaListDTO } from '../../model/dtos/mob/vistoria.dto';
import { ApiController } from '../api-controller.interface';
import { VistoriaDTO } from './../../model/dtos/mob/vistoria.dto';

@Injectable()
export class VistoriaController implements ApiController<Vistoria> {

	constructor() { }

	getEnderecos(id?: number): Promise<VistoriaDTO[]>{
		let request = new Quark(
			new HttpGet({
				url: new Url({
					id:'mob/vistoria/enderecos',
					environment: environmentv3
				}),
			}),
			new HttpResponse(new Array<VistoriaDTO>())
		);
			return request.call();
	}

	async salvar(vistoria: VistoriaDTO): Promise<VistoriaDTO> {
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/vistoria',
					environment: environmentv3
				}),
				data: new JSONData(vistoria)
			}),
			new HttpResponse(
				new VistoriaDTO()
			)
		);
		return await quark.call();
	}

	async salvarLote(array): Promise<Array<VistoriaDTO>> {
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/vistoria/lote',
					environment: environmentv3
				}),
				data: new JSONData(array)
			}),
			new HttpResponse(
				new VistoriaDTO()
			)
		);
		return await quark.call();
	}

	async atualizar(vistoria: VistoriaDTO): Promise<VistoriaDTO> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/vistoria/:cdVistoria',
					environment: environmentv3,
					pathParams: new JSONData({ cdVistoria: vistoria.cdVistoria })
				}),
				data: new JSONData(vistoria)
			}),
			new HttpResponse(
				new VistoriaDTO()
			)
		);
		return await quark.call();
	}
	
	getvistorias(id: number): Promise<VistoriaDTO>{
		let request = new Quark(
			new HttpGet({
				url: new Url({
					id:'mob/vistoria/:cdVistoria',
					environment: environmentv3,
					pathParams : new JSONData({ cdVistoria: id }),
				}),
			}),
			new HttpResponse(new VistoriaDTO())
		);
			return request.call();
	}

	async find(filtros?: IFilter): Promise<VistoriaListDTO> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/vistorias',
					environment: environmentv3,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new VistoriaListDTO()
			)
		);
		return await quark.call();
	}

	async relatorioVistoriaItemReprovados(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/vistorias/relatorio/reprovados',
                    environment: environment,
                    filter: filtros
                }),
				responseType: 'Blob'
            }),
            new HttpResponse(
               new Blob()
            )
        );
        return await quark.call()
    }

	async relatorioVistoria(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/vistorias/relatorio/vistorias',
                    environment: environment,
                    filter: filtros
                }),
				responseType: 'Blob'
            }),
            new HttpResponse(
               new Blob()
            )
        );
        return await quark.call()
    }
	
	async findVistoriador(filtros?: IFilter): Promise<Array<Vistoria>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/vistorias/vistoriador',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Vistoria>(), 60000
			)
		);
		return await quark.call();
	}

	async findConcessionario(filtros?: IFilter): Promise<Array<Vistoria>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/vistorias/concessionario',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Vistoria>()
			)
		);
		return await quark.call();
	}

	async findVistoria(filtros?: IFilter): Promise<Array<Vistoria>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/vistorias/find',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Vistoria>()
			)
		);
		return await quark.call();
	}

	async get(cdVistoria: number): Promise<VistoriaDTO> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/vistorias/:cdVistoria',
					environment: environment,
					pathParams: new JSONData({ cdVistoria: cdVistoria })
				}),
			}),
			new HttpResponse(
				new VistoriaDTO()
			)
		);
		return await quark.call();
	}

	async create(vistoria: Vistoria): Promise<Vistoria> {
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/vistorias',
					environment: environment
				}),
				data: new JSONData(vistoria)
			}),
			new HttpResponse(
				new Vistoria()
			)
		);
		return await quark.call();
	}

	async createLote(array): Promise<Array<Vistoria>> {
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/vistorias/lote',
					environment: environment
				}),
				data: new JSONData(array)
			}),
			new HttpResponse(
				new Vistoria()
			)
		);
		return await quark.call();
	}

	async update(vistoria: Vistoria): Promise<Vistoria> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/vistorias/:cdVistoria',
					environment: environment,
					pathParams: new JSONData({ cdVistoria: vistoria.cdVistoria })
				}),
				data: new JSONData(vistoria)
			}),
			new HttpResponse(
				new Vistoria()
			)
		);
		return await quark.call();
	}

	async delete(cdVistoria: number){
		let quark = new Quark(
			new HttpDelete({
				url: new Url({
					id: 'mob/vistorias/:cdVistoria',
					environment: environment,
					pathParams: new JSONData({ cdVistoria: cdVistoria })
				}),
			}),
			new HttpResponse(
				new VistoriaDTO()
			)
		);
		return await quark.call();
	}
	

}